import Swiper from "swiper/bundle"
import AOS from "aos"
import Chart from "chart.js/auto"
import { getRelativePosition } from "chart.js/helpers"
import ChartDeferred from "chartjs-plugin-deferred"
// Add your JS customizations here
jQuery(document)
	.ready(function($) {
		/******************************************
	Variables
******************************************/
		var body = $("body")
		/******************************************
	General features
******************************************/
		$(".scroll-top-link")
			.on("click", function() {
				window.scrollTo(0, 0)
			})
		/******************************************
	Page scroll
******************************************/
		function scroll_page() {
			var scroll = $(window)
				.scrollTop()
			var documentHeight = $(document)
				.height()
			var windowHeight = $(window)
				.height()
			// Add class when scroll
			if (scroll >= 125) {
				$("body")
					.addClass("window-scroll")
			} else {
				$("body")
					.removeClass("window-scroll")
			}
		}
		$(window)
			.on("scroll", scroll_page)
		/******************************************
	smooth scroll to accordeon
******************************************/
		$(".accordion-collapse")
			.on("shown.bs.collapse", function(e) {
				var $accordion_item = $(this)
					.parent(".accordion-item")
				var $offset = $accordion_item.offset()
					.top
				$("html,body")
					.animate({
						scrollTop: $offset - 100,
					}, 500)
			})
		/******************************************
	Navigation
******************************************/
		$(".hamburger-wrapper")
			.on("click", function() {
				if (body.hasClass("main-menu-open")) {
					body.removeClass("main-menu-open no-overflow")
				} else {
					body.addClass("main-menu-open no-overflow")
				}
			})
		$(".menu-anchor")
			.on("click", function() {
				body.removeClass("main-menu-open no-overflow")
			})
		/******************************************
	Smooth scroll to anchor
******************************************/
		// Select all links with hashes
		$('a[href*="#"]')
			// Remove links that don't actually link to anything
			.not('[href="#"]')
			.not('[href="#0"]')
			.click(function(event) {
				// On-page links
				if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
					// Figure out element to scroll to
					var target = $(this.hash)
					target = target.length ? target : $("[name=" + this.hash.slice(1) + "]")
					// Does a scroll target exist?
					if (target.length) {
						// Only prevent default if animation is actually gonna happen
						event.preventDefault()
						$("html, body")
							.animate({
								scrollTop: target.offset()
									.top - 150,
							}, 1000, function() {
								// Callback after animation
								// Must change focus!
								var $target = $(target)
								$target.focus()
								if ($target.is(":focus")) {
									// Checking if the target was focused
									return false
								} else {
									$target.attr("tabindex", "-1") // Adding tabindex for elements not focusable
									$target.focus() // Set focus again
								}
							})
					}
				}
			})
		/******************************************
			Swipers
		******************************************/
		const swiperGenese = new Swiper(".swiper-genese", {
			// Optional parameters
			loop: false,
			grabCursor: true,
			speed: 1000,
			// Navigation arrows
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
		})
		swiperGenese.on("slideChange", function() {
			if (swiperGenese.activeIndex > swiperGenese.previousIndex) {
				$("#swiper-bar-" + swiperGenese.activeIndex)
					.addClass("hide")
			} else {
				$("#swiper-bar-" + swiperGenese.previousIndex)
					.removeClass("hide")
			}
		})
		$("#genese-next")
			.on("click", function() {
				swiperGenese.slideNext()
			})
		$("#genese-prev")
			.on("click", function() {
				swiperGenese.slidePrev()
			})
		const swiper_timeline_year = new Swiper(".swiper-timeline-year", {
			// Optional parameters
			loop: false,
			grabCursor: false,
			slidesPerView: 1,
			effect: "fade",
			allowTouchMove: false,
		})
		const swiper_timeline_text = new Swiper(".swiper-timeline-text", {
			// Optional parameters
			loop: false,
			grabCursor: true,
			centeredSlides: true,
			slidesPerView: 1,
			spaceBetween: 0,
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			pagination: {
				el: ".swiper-pagination",
			},
			controller: {
				control: swiper_timeline_year,
			},
		})
		//JQuery end
	})
/******************************************
	AOS
******************************************/
setTimeout(function() {
	AOS.init({
		duration: 800, // values from 0 to 3000, with step 50ms
	})
}, 1200)
/******************************************
	 Chart.js
 ******************************************/
Chart.register(ChartDeferred)
const isPageGraph = document.querySelectorAll(".graph-section")
if (isPageGraph.length) {

	const tooltip = {
		callbacks: {
			label: function(context){
				return ' ' + context.label
			}

		}
	};

	var chartOptions = {
		cutout: "70%",
		layout: {
			padding: {
				bottom: 30,
			},
		},
		plugins: {
			legend: {
				labels: {
					// This more specific font property overrides the global property
					font: {
						size: 12,
						family: "Roboto, sans-serif",
					},
					color: "#000000",
					padding: 10,
					boxWidth: 20,
					boxHeight: 20,
				},
				position: "right",
				display: false,
			},
			tooltip,
			deferred: {
				xOffset: 150, // defer until 150px of the canvas width are inside the viewport
				yOffset: "40%", // defer until 50% of the canvas height are inside the viewport
				delay: 0, // delay of 500 ms after the canvas is considered inside the viewport
			},
		},
		hoverOffset: 10,
		// aspectRatio: 1/2,
		onResize: "changeLabelPosition",
		animation: {
			duration: 2000,
			delay: 400,
		},
	}
	/***************************
	Chart section 02
	***************************/
	const dataset0201 = [
		{title: "Oui   (50,2%)", value: 50.2, color: "#C00A7A" },
		{title: "Non   (46,4%)", value: 46.4, color: "#FF7BAC" },
		{title: "Préfère ne pas répondre   (0,7%)", value: 0.7, color: "#FFDDEA",},
		{ title: "Ne sait pas   (2,8%)", value: 2.8, color: "#FFB2CF" }
	]

	const chart0201 = new Chart(document.getElementById("chart0201"), {
		type: "doughnut",
		data: {
			labels: dataset0201.map((row) => row.title),
			datasets: [{
				label: "",
				data: dataset0201.map((row) => row.value),
				backgroundColor: dataset0201.map((row) => row.color),
				borderWidth: 0,
				weight: 8,
			}, ],
		},
		options: chartOptions,
	})
	var dataset0202 = {
		labels: ["Oui   (30,8%)", "Non   (68,5%)", "Préfère ne pas répondre   (0,7%)", ],
		datasets: [{
			label: "",
			data: [30.8, 68.5, 0.7],
			backgroundColor: ["#C00A7A", "#FF7BAC", "#FFDDEA"],
			borderWidth: 0,
			weight: 8,
		}, ],
	}
	const chart0202 = new Chart(document.getElementById("chart0202"), {
		type: "doughnut",
		data: dataset0202,
		options: chartOptions,
	})
	var dataset0203 = {
		labels: ["Oui   (55,7%)", "Non   (36,7%)", "Préfère ne pas répondre   (7,6%)", ],
		datasets: [{
			label: "",
			data: [55.7, 36.7, 7.6],
			backgroundColor: ["#C00A7A", "#FF7BAC", "#FFDDEA"],
			borderWidth: 0,
			weight: 8,
		}, ],
	}
	const chart0203 = new Chart(document.getElementById("chart0203"), {
		type: "doughnut",
		data: dataset0203,
		options: chartOptions,
	})
	var dataset0204 = {
		labels: ["Très satisfait-e   (77,9%)", "Satisfait-e   (15,9%)", "Insatisfait-e   (1%)", "Très insatisfait-e   (2,4%)", "Préfère ne pas répondre   (2,8%)", ],
		datasets: [{
			label: "",
			data: [77.9, 15.9, 1, 2.4, 2.8],
			backgroundColor: ["#C00A7A", "#FF7BAC", "#F6B1CA", "#F6EFF1", "#F7DDE6", ],
			borderWidth: 0,
			weight: 8,
		}, ],
	}
	const chart0204 = new Chart(document.getElementById("chart0204"), {
		type: "doughnut",
		data: dataset0204,
		options: chartOptions,
	})
	/***************************
	Chart section 03
	***************************/
	var dataset0301 = {
		labels: ["En famille   (38,8%)","Seul-e   (31,5%)", "Entre ami-es   (28,7%)", "Préfère ne pas répondre   (1%)", ],
		datasets: [{
			label: "",
			data: [38.8, 28.7, 31.5, 1],
			backgroundColor: ["#00756F", "#D7DCCA", "#748743", "#4AB2AD"],
			borderWidth: 0,
			weight: 8,
		}, ],
	}
	const chart0301 = new Chart(document.getElementById("chart0301"), {
		type: "doughnut",
		data: dataset0301,
		options: chartOptions,
	})
	var dataset0302 = {
		labels: ["5 ans et moins - 2018 et plus   (27%)", "6 à 14 ans - 2009 à 2017   (61,5%)", "15 à 17 ans - 2008 à 2006    (6,8%)", "18 ans et plus - 2005 et moins   (1,4%)", "Préfère ne pas répondre   (3,4%)", ],
		datasets: [{
			label: "",
			data: [27, 61.5, 6.8, 1.4, 3.4],
			backgroundColor: ["#00756F", "#748743", "#D7DCCA", "#9EAC7B", "#4AB2AD", ],
			borderWidth: 0,
			weight: 8,
		}, ],
	}
	const chart0302 = new Chart(document.getElementById("chart0302"), {
		type: "doughnut",
		data: dataset0302,
		options: chartOptions,
	})
	var dataset0303 = {
		labels: ["Oui   (86,2%)", "Non   (11,8%)", "Préfère ne pas répondre   (2,1%)", ],
		datasets: [{
			label: "",
			data: [86.2, 11.8, 2.1],
			backgroundColor: ["#748743", "#00756F", "#4AB2AD"],
			borderWidth: 0,
			weight: 8,
		}, ],
	}
	const chart0303 = new Chart(document.getElementById("chart0303"), {
		type: "doughnut",
		data: dataset0303,
		options: chartOptions,
	})
	/***************************
	Chart section 04
	***************************/

	var chartOptionsBarFirst = {
		layout: {
			padding: {
				bottom: 30,
			},
		},
		plugins: {
			legend: {
				labels: {
					// This more specific font property overrides the global property
					font: {
						size: 12,
						family: "Roboto, sans-serif",
					},
					color: "#000000",
					padding: 10,
					boxWidth: 20,
					boxHeight: 20,
				},
				position: "bottom",
				display: false,
			},
			tooltip:{
				callbacks:{
					label: (context) => {
						return context.label
					},
					title: (context) => {
						return ''
					}
				}
			},
		},
		animation: false,
		parsing: {
			xAxisKey: "data.value",
			yAxisKey: "data.title",
		},
		scales: {
			y: {
				type: "linear",
				min: 0,
				max: 60,
			},
			x: {
				display: false,
			},
		},
		indexAxis: "x",
	}

	const dataset0601 = [
		{ title: "Abitibi-Témiscamingue   (20,7%)", value: 20.7, color: "#D4E1ED" },
		{ title: "Montréal   (13,4%)", value: 13.4, color: "#9ACBF7" },
		{ title: "Laurentides  (12,7%)", value: 12.7, color: "#00615C" },
		{ title: "Capitale-Nationale   (11,2%)", value: 11.2, color: "#BC6E9E" },
		{ title: "Gaspésie-Îles-de-la-Madeleine   (10,1%)", value: 10.1, color: "#40ACA7"},
		{ title: "Chaudière-Appalaches  (8,7%)", value: 8.7, color: "#748743" },
		{ title: "Montérégie  (7,2%)", value: 7.2, color: "#E2E6D6" },
		{ title: "Lanaudière   (3,6%)", value: 3.6, color: "#F7CDE7" },
		{ title: "Bas-Saint-Laurent   (3,3%)", value: 3.3, color: "#5091C9" },
		{ title: "Estrie   (2,2%)", value: 2.2, color: "#2A6CA5" },
		{ title: "Côte-Nord   (2,2%)", value: 2.2, color: "#FF7BAC" },
		{ title: "Centre-du-Québec    (1,4%)", value: 1.4, color: "#E3A8CD" },
		{ title: "Laval   (1,4%)", value: 1.4, color: "#9EAC7B" },
		{ title: "Mauricie   (1,1%)", value: 1.1, color: "#747474" },
		{ title: "Outaouais   (0,7%)", value: 0.7, color: "#B93686" },
	]

	var theachart0601 = document.getElementById("chart0601");
	if (theachart0601) {
		const chart0601 = new Chart(theachart0601, {
			type: "doughnut",
			data: {
				labels: dataset0601.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataset0601.map((row) => row.value),
					backgroundColor: dataset0601.map((row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptions,
		})
	}


	var dataset0602 = {
		labels: ["Féminin   (71,3%)", "Masculin   (26,3%)", "Non binaire   (0,3%)", "Préfère ne pas répondre   (2,1%)", ],
		datasets: [{
			label: "",
			data: [71.3, 26.3, 0.3, 2.1],
			backgroundColor: ["#00756F", "#BC6E9E", "#F7CDE7", "#BAEBE9"],
			borderWidth: 0,
			weight: 8,
		}, ],
	}
	const chart0602 = new Chart(document.getElementById("chart0602"), {
		type: "doughnut",
		data: dataset0602,
		options: chartOptions,
	})


	const dataset0401 = [
		{ title: "Musique, concerts, chant, chanson   (54,3%)", value: 54.3, color: "#00615C" },
		{ title: "Expositions, loisirs créatifs   (34,3%)", value: 34.3, color: "#BC6E9E" },
		{ title: "Musées, histoire, patrimoine, architecture   (27,7%)", value: 27.7, color: "#F7DDE6"},
		{ title: "Littérature, lecture, conte, poésie   (27,3%)", value: 27.3, color: "#748743" },
		{ title: "Théâtre   (23,9%)", value: 23.9, color: "#D4E1ED" },
		{ title: "Dessin, peinture, écriture, photo   (23,5%)", value: 23.5, color: "#9ACBF7" },
		{ title: "Découverte et curiosité   (18,3%)", value: 18.3, color: "#9EAC7B" },
		{ title: "Cinéma   (18%)", value: 18, color: "#40ACA7" },
		{ title: "Danse   (17,6%)", value: 17.6, color: "#5091C9" },
		{ title: "Sport, nature et plein air   (17%)", value: 17, color: "#2A6CA5" },
		{ title: "Artisanat   (16,6%)", value: 16.6, color: "#C00A7A" },
		{ title: "Spectacle, cirque, humour   (16,6%)", value: 16.6, color: "#E1E5D4" },
		{ title: "Cuisine et gastronomie   (7,6%)", value: 7.6, color: "#E3A8CD" },
		{ title: "Science, technologie, santé   (3,5%)", value: 3.5, color: "#FF7BAC" },
		{ title: "Jardinage et horticulture    (2,8%)", value: 2.8, color: "#747474" },
		{ title: "Jeux   (2,4%)", value: 2.4, color: "#AEC5DA" },
	]



	var thechart0401 = document.getElementById("chart0401");
	if (thechart0401) {
		const chart0401 = new Chart(document.getElementById("chart0401"), {
			type: "bar",
			data: {
				labels: dataset0401.map((row) => row.title),
				datasets: [{
					label: "",
					axis: "y",
					data: dataset0401.map((row) => row.value),
					backgroundColor: dataset0401.map((row) => row.color),
					borderWidth: 0,
				}, ],
			},
			options: chartOptionsBarFirst,
		})
	}




}
const isPageGraRapport = document.querySelectorAll("#rapports-jdc-wrapper")
if (isPageGraRapport.length) {

	const tooltip = {
		callbacks: {
			label: function(context){
				return ' ' + context.label
			}

		}
	};

	var chartOptionsBar = {
		layout: {
			padding: {
				bottom: 30,
			},
		},
		plugins: {
			legend: {
				labels: {
					// This more specific font property overrides the global property
					font: {
						size: 12,
						family: "Roboto, sans-serif",
					},
					color: "#000000",
					padding: 10,
					boxWidth: 20,
					boxHeight: 20,
				},
				position: "bottom",
				display: false,
			},
			tooltip:{
				callbacks:{
					label: (context) => {
						return context.label
					},
					title: (context) => {
						return ''
					}
				}
			},
		},
		animation: false,
		parsing: {
			xAxisKey: "data.value",
			yAxisKey: "data.title",
		},
		scales: {
			y: {
				type: "linear",
				min: 0,
				max: 100,
			},
			x: {
				display: false,
			},
		},
		indexAxis: "x",
	}
	var chartOptionsBar60 = {
		layout: {
			padding: {
				bottom: 30,
			},
		},
		plugins: {
			legend: {
				labels: {
					// This more specific font property overrides the global property
					font: {
						size: 12,
						family: "Roboto, sans-serif",
					},
					color: "#000000",
					padding: 10,
					boxWidth: 20,
					boxHeight: 20,
				},
				position: "bottom",
				display: false,
			},
			tooltip:{
				callbacks:{
					label: (context) => {
						return context.label
					},
					title: (context) => {
						return ''
					}
				}
			},
		},
		animation: false,
		parsing: {
			xAxisKey: "data.value",
			yAxisKey: "data.title",
		},
		scales: {
			y: {
				type: "linear",
				min: 0,
				max: 60,
			},
			x: {
				display: false,
			},
		},
		indexAxis: "x",
	}
	var chartOptionsBar70 = {
		layout: {
			padding: {
				bottom: 30,
			},
		},
		plugins: {
			legend: {
				labels: {
					// This more specific font property overrides the global property
					font: {
						size: 12,
						family: "Roboto, sans-serif",
					},
					color: "#000000",
					padding: 10,
					boxWidth: 20,
					boxHeight: 20,
				},
				position: "bottom",
				display: false,
			},
			tooltip:{
				callbacks:{
					label: (context) => {
						return context.label
					},
					title: (context) => {
						return ''
					}
				}
			},
		},
		animation: false,
		parsing: {
			xAxisKey: "data.value",
			yAxisKey: "data.title",
		},
		scales: {
			y: {
				type: "linear",
				min: 0,
				max: 70,
			},
			x: {
				display: false,
			},
		},
		indexAxis: "x",
	}
	var chartOptionsBar50 = {
		layout: {
			padding: {
				bottom: 30,
			},
		},
		plugins: {
			legend: {
				labels: {
					// This more specific font property overrides the global property
					font: {
						size: 12,
						family: "Roboto, sans-serif",
					},
					color: "#000000",
					padding: 10,
					boxWidth: 20,
					boxHeight: 20,
				},
				position: "bottom",
				display: false,
			},
			tooltip:{
				callbacks:{
					label: (context) => {
						return context.label
					},
					title: (context) => {
						return ''
					}
				}
			},
		},
		animation: false,
		parsing: {
			xAxisKey: "data.value",
			yAxisKey: "data.title",
		},
		scales: {
			y: {
				type: "linear",
				min: 0,
				max: 50,
			},
			x: {
				display: false,
			},
		},
		indexAxis: "x",
	}

	var chartOptionsBar75 = {
		layout: {
			padding: {
				bottom: 30,
			},
		},
		plugins: {
			legend: {
				labels: {
					// This more specific font property overrides the global property
					font: {
						size: 12,
						family: "Roboto, sans-serif",
					},
					color: "#000000",
					padding: 10,
					boxWidth: 20,
					boxHeight: 20,
				},
				position: "bottom",
				display: false,
			},
			tooltip:{
				callbacks:{
					label: (context) => {
						return context.label
					},
					title: (context) => {
						return ''
					}
				}
			},
		},
		animation: false,
		parsing: {
			xAxisKey: "data.value",
			yAxisKey: "data.title",
		},
		scales: {
			y: {
				type: "linear",
				min: 0,
				max: 80,
			},
			x: {
				display: false,
			},
		},
		indexAxis: "x",
	}
var chartOptionsBar90 = {
		layout: {
			padding: {
				bottom: 30,
			},
		},
		plugins: {
			legend: {
				labels: {
					// This more specific font property overrides the global property
					font: {
						size: 12,
						family: "Roboto, sans-serif",
					},
					color: "#000000",
					padding: 10,
					boxWidth: 20,
					boxHeight: 20,
				},
				position: "bottom",
				display: false,
			},
			tooltip:{
				callbacks:{
					label: (context) => {
						return context.label
					},
					title: (context) => {
						return ''
					}
				}
			},
		},
		animation: false,
		parsing: {
			xAxisKey: "data.value",
			yAxisKey: "data.title",
		},
		scales: {
			y: {
				type: "linear",
				min: 0,
				max: 90,
			},
			x: {
				display: false,
			},
		},
		indexAxis: "x",
	}
	var chartOptionsDonut02 = {
		cutout: "50%",
		layout: {
			padding: {
				bottom: 30,
			},
		},
		plugins: {
			legend: {
				labels: {
					// This more specific font property overrides the global property
					font: {
						size: 12,
						family: "Roboto, sans-serif",
					},
					color: "#000000",
					padding: 10,
					boxWidth: 20,
					boxHeight: 20,
				},
				position: "bottom",
				display: false,
			},
			tooltip,
		},
		hoverOffset: 10,
		animation: false,
		aspectRatio: 1,
	}


	var chartOptionsDonut02 = {
		cutout: "50%",
		layout: {
			padding: {
				bottom: 30,
			},
		},
		plugins: {
			legend: {
				labels: {
					// This more specific font property overrides the global property
					font: {
						size: 12,
						family: "Roboto, sans-serif",
					},
					color: "#000000",
					padding: 10,
					boxWidth: 20,
					boxHeight: 20,
				},
				position: "bottom",
				display: false,
			},
			tooltip,
		},
		hoverOffset: 10,
		animation: false,
		aspectRatio: 1,
	}


	const dataActiviteenFr = [
	{title:'Non (4,8%)',value:4.8, color:'#6C9EC9'},
	{title:'Oui (66,4%)',value:66.4, color:'#D32A92'},
	{title:'Cela n\'a pas d\'importance (28,1%)',value:28.1, color:'#FFF44F'},
	{title:'Préfère ne pas répondre (0,7%)',value:0.7, color:'#b9b6b6'},
	]
	var theactiviteFrancais = document.getElementById("activiteFrancais")
	if (theactiviteFrancais) {
		const activiteFrancais = new Chart(theactiviteFrancais, {
			type: "doughnut",
			data: {
				labels: dataActiviteenFr.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataActiviteenFr.map((row) => row.value),
					backgroundColor: dataActiviteenFr.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}


	const dataProduiteQuebec = [
	{title:'Non (6,8%)',value:6.8,color:'#6C9EC9'},
	{title:'Oui (64,7%)',value:64.7,color:'#D32A92'},
	{title:'Cela n\'a pas d\'importance (26,4%)',value:26.4,color:'#FFF44F'},
	{title:'Préfère ne pas répondre (2,1%)',value:2.1,color:'#b9b6b6'},

	]
	var theproduiteQuebec = document.getElementById("produiteQuebec")
	if (theproduiteQuebec) {
		const produiteQuebec = new Chart(theproduiteQuebec, {
			type: "doughnut",
			data: {
				labels: dataProduiteQuebec.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataProduiteQuebec.map((row) => row.value),
					backgroundColor: dataProduiteQuebec.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}




	const dataset1000 = [
		{ title: "Musique", value: 45.9, color: "#028982" },
		{ title: "Dessin", value: 45.6, color: "#6FBDB9" },
		{ title: "Danse", value: 27.3, color: "#899B5A" },
		{ title: "Théâtre", value: 17, color: "#CBD2B8" },
		{ title: "Cirque", value: 3.05, color: "#D32A92" },
		{ title: "Art de la parole", value: 16.7, color: "#E494C6" },
		{ title: "Création littéraire", value: 31.9, color: "#FF9DC2" },
		{ title: "Graffiti et murales", value: 4.1, color: "#FDD6E4" },
		{ title: "Photographie", value: 24.5, color: "#FFF44F" },
		{ title: "Création numérique", value: 17, color: "#FCF6A7" },
		{ title: "Sculpture,  peinture,  arts, textiles, arts d’impression", value: 20.8, color: "#6C9EC9"},
		{ title: "Artisanat", value: 13.6, color: "#C1DDF5" },
		{ title: "Autre", value: 8.5, color: "#4285f4" },
		{ title: "Ne pas répondre", value: 0.3, color: "#131313" },
		{ title: "Aucune", value: 10.5, color: "#b9b6b6" },
		{ title: "Sport", value: 4.1, color: "#b889e9" },
	]

	const dataset3000 = [
		{ title: "Abitibi-Témiscamingue", value: "20.1", color: "#028982" },
		{ title: "Capitale Nationale", value: "8.0", color: "#6FBDB9" },
		{ title: "Centre-du-Québec", value: "1.4", color: "#899B5A" },
		{ title: "Chaudière-Appalaches", value: "9.0", color: "#CBD2B8" },
		{ title: "Côte-Nord", value: "2.1", color: "#D32A92" },
		{ title: "Estrie", value: "2.8", color: "#E494C6" },
		{ title: "Gaspésie-Îles-de-la-Madeleine", value: "12.8", color: "#FF9DC2"},
		{ title: "Lanaudière", value: "3.1", color: "#FDD6E4" },
		{ title: "Laurentides", value: "9.7", color: "#FFF44F" },
		{ title: "Laval", value: "1.7", color: "#FCF6A7" },
		{ title: "Montérégie", value: "3.1", color: "#6C9EC9" },
		{ title: "Montréal", value: "8.0", color: "#C1DDF5" },
		{ title: "Outaouais", value: "1.7", color: "#4285f4" },
		{ title: "Localisation inconnue", value: "16.6", color: "#131313" },
	]
	var thechart1000 = document.getElementById("chart1000")
	if (thechart1000) {
		const chart1000 = new Chart(document.getElementById("chart1000"), {
			type: "bar",
			data: {
				labels: dataset1000.map((row) => row.title),
				datasets: [{
					label: "Activités artistiques",
					axis: "y",
					data: dataset1000.map((row) => row.value),
					backgroundColor: dataset1000.map((row) => row.color),
					borderWidth: 0,
					// base: 0,
					// barPercentage: 0.5,
				}, ],
			},
			options: chartOptionsBar,
		})
	}
	const dataParticipation = [
		{title:'Oui (50,2%)',value:50.2,color:'#AEDDDB'},
		{title:'Non (46,4%)',value:46.4,color:'#028982'},
		{title:'Ne sais pas (2,8%)',value:2.8,color:'#FCF6A7'},
		{title:'Préfère ne pas répondre (0,7%)',value:0.7,color:'#b9b6b6'},

	]
	var theparticipation = document.getElementById("participation")
	if (theparticipation) {
		const participation = new Chart(document.getElementById("participation"), {
			type: "doughnut",
			data: {
				labels: dataParticipation.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataParticipation.map((row) => row.value),
					backgroundColor: dataParticipation.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}
	const dataEnfantQt = [
		{title:'0 enfant (19,6%)',value:19.6,color:'#6C9EC9'},
		{title:'1 enfant (36,6%)',value:36.6,color:'#028982'},
		{title:'2 enfants (27,7%)',value:27.7,color:'#D32A92'},
		{title:'3 enfants (12,5%)',value:12.5,color:'#FFF44F'},
		{title:'4 enfants (0,9%)',value:0.9,color:'#AEDDDB'},
		{title:'Préfère ne pas répondre (2,7%)',value:2.7,color:'#b9b6b6'},
	]
	var theEnfantQt = document.getElementById("enfantQt")
	if (theEnfantQt) {
		const enfantQt = new Chart(document.getElementById("enfantQt"), {
			type: "doughnut",
			data: {
				labels: dataEnfantQt.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataEnfantQt.map((row) => row.value),
					backgroundColor: dataEnfantQt.map((row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}
	const dataEnfantAge = [
		{title:'5 ans et moins (2018 et plus) (27%)',value:27,color:'#4EA8A3'},
		{title:'6 à 14 ans (2009 à 2017) (61,5%)',value:61.5,color:'#AEDDDB'},
		{title:'15 à 17 ans (2008 à 2006) (6,8%)',value:6.8,color:'#6C9EC9'},
		{title:'18 ans et plus (2005 et moins) (1,4%)',value:1.4,color:'#C1DDF5'},
		{title:'Préfère ne pas répondre (3,4%)',value:3.4,color:'#b9b6b6'},
	 ]
	var theEnfantAge = document.getElementById("enfantAge")
	if (theEnfantAge) {
		const enfantAge = new Chart(theEnfantAge, {
			type: "doughnut",
			data: {
				labels: dataEnfantAge.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataEnfantAge.map((row) => row.value),
					backgroundColor: dataEnfantAge.map((row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}
	const dataSatisfaction = [
		{ title: "Très satisfait-e (77,9%)", value: 77.9, color: "#028982" },
		{ title: "Satisfait-e (15,9%)", value: 15.9, color: "#6FBDB9" },
		{ title: "Insatisfait-e (1%)", value: 1, color: "#D32A92" },
		{ title: "Très insatisfait-e (2,4%)", value: 2.4, color: "#E494C6" },
		{ title: "Préfère ne pas répondre (2,8%)", value: 2.8, color: "#b9b6b6" },
	]
	var theSatisfaction = document.getElementById("satisfaction")
	if (theSatisfaction) {
		const satisfaction = new Chart(theSatisfaction, {
			type: "doughnut",
			data: {
				labels: dataSatisfaction.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataSatisfaction.map((row) => row.value),
					backgroundColor: dataSatisfaction.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}

	const dataRencontre02 = [
		{ title: "Oui (86,2%)", value: 86.2, color: "#6C9EC9" },
		{ title: "Non (11,8%)", value: 11.8, color: "#028982" },
		{ title: "Préfère ne pas répondre (2,1%)",value: 2.1,color: "#b9b6b6"},
	]

	var therencontre02 = document.getElementById("rencontre02")
	if (therencontre02) {
		const participationAutre = new Chart(therencontre02, {
			type: "doughnut",
			data: {
				labels: dataRencontre02.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataRencontre02.map(
						(row) => row.value),
					backgroundColor: dataRencontre02.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}





	const dataParticipationAutre = [
		{ title: "Oui (30,8%)", value: 30.8, color: "#6C9EC9" },
		{ title: "Non (68,5%)", value: 68.5, color: "#028982" },
		{title: "Préfère ne pas répondre (0,7%)", value: 0.7, color: "#b9b6b6"},
	]
	var theparticipationAutre = document.getElementById("participationAutre")
	if (theparticipationAutre) {
		const participationAutre = new Chart(theparticipationAutre, {
			type: "doughnut",
			data: {
				labels: dataParticipationAutre.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataParticipationAutre.map(
						(row) => row.value),
					backgroundColor: dataParticipationAutre.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}


	const dataSecteurActivite = [
		{ title: "5 activités (33,2%)", value: 33.2, color: "#028982" },
		{ title: "4 activités (11,1%)", value: 11.1, color: "#6FBDB9" },
		{ title: "3 activités (17%)", value: 17, color: "#D32A92" },
		{ title: "2 activités (6,6%)", value: 6.6, color: "#E494C6" },
		{ title: "1 activité (4,2%)", value: 4.2, color: "#FDD6E4" },
	]
	var thesecteurActivite = document.getElementById("secteurActivite")
	if (thesecteurActivite) {
		const secteurActivite = new Chart(document.getElementById("secteurActivite"), {
			type: "bar",
			data: {
				labels: dataSecteurActivite.map((row) => row.title),
				datasets: [{
					label: "",
					axis: "y",
					// barPercentage: 1,
					// barThickness: 20,
					// maxBarThickness: 20,
					data: dataSecteurActivite.map((row) => row.value),
					backgroundColor: dataSecteurActivite.map(
						(row) => row.color),
					borderWidth: 0,
					// base: 0,
					// barPercentage: 0.5,
				}, ],
			},
			options: chartOptionsBar,
		})
	}
	const dataAgeRepondants = [
		{title: '15 à 24 ans (2008 à 1999) (3,8%)',value: 3.8, color:'#6C9EC9'},
		{title: '25 à 34 ans (1998 à 1989) (12,1%)', value: 12.1, color:'#028982'},
		{title: '35 à 44 ans (1988 à 1979) (23,9%)', value: 23.9, color:'#D32A92'},
		{title: '45 à 54 ans (1978 à 1969) (14,9%)', value: 14.9, color:'#FFF44F'},
		{title: '55 à 64 ans (1968 à 1959) (14,5%)', value: 14.5, color:'#4285f4'},
		{title: '65 à 74 ans (1958 à 1949) (21,1%)', value: 21.1, color:'#AEDDDB'},
		{title: '75 ans et plus (5,9%)', value: 5.9, color:'#b9b6b6'},
		{title: 'Préfère ne pas répondre (3,8%)', value: 3.8, color:'#DCEBF8'},
	]
	var theageRepondants = document.getElementById("ageRepondants")
	if (theageRepondants) {
		const ageRepondants = new Chart(document.getElementById("ageRepondants"), {
			type: "doughnut",
			data: {
				labels: dataAgeRepondants.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataAgeRepondants.map((row) => row.value),
					backgroundColor: dataAgeRepondants.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}
	const dataRegions = [{ title: "Capitale-Nationale (10,7%)", value: 10.7, color: "#6C9EC9" }, { title: "Centre-du-Québec (1,4%)", value: 1.4, color: "#C1DDF5" }, { title: "Chaudière-Appalaches (8,3%)", value: 8.3, color: "#028982" }, { title: "Côte-Nord (2,1%)", value: 2.1, color: "#6FBDB9" }, { title: "Estrie (2,1%)", value: 2.1, color: "#D32A92" }, {
		title: "Gaspésie-Îles-de-la-Madeleine (9,7%)",
		value: 9.7,
		color: "#E494C6",
	}, { title: "Lanaudière (3,5%)", value: 3.5, color: "#FFF44F" }, { title: "Laurentides (12,1%)", value: 12.1, color: "#FCF6A7" }, { title: "Laval (1,4%)", value: 1.4, color: "#899B5A" }, { title: "Mauricie (1%)", value: 1, color: "#CBD2B8" }, { title: "Montérégie (6,9%)", value: 6.9, color: "#FF9DC2" }, { title: "Montréal (12,8%)", value: 12.8, color: "#FDD6E4" }, { title: "Outaouais (0,7%)", value: 0.7, color: "#b889e9" }, {
		title: "Préfère ne pas répondre (4,5%)",
		value: 4.5,
		color: "#b9b6b6",
	}, ]
	var theregionsResidence = document.getElementById("regionsResidence")
	if (theregionsResidence) {
		const regionsResidence = new Chart(document.getElementById("regionsResidence"), {
			type: "doughnut",
			data: {
				labels: dataRegions.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataRegions.map((row) => row.value),
					backgroundColor: dataRegions.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}

	const dataLangue = [
	{title:'Français (99%)',value:99.0,color:'#AEDDDB'},
	{title:'Anglais (23,9%)',value:23.9,color:'#028982'},
	{title:'Espagnol (3,5%)',value:3.5,color:'#899B5A'},
	{title:'Autre (4,2%)',value:4.2,color:'#4285f4'},
	{title:'Préfère ne pas répondre (1%)',value:1.0,color:'#b9b6b6'},
	];


	var thelanguesParle = document.getElementById("languesParle")
	if (thelanguesParle) {
		const languesParle = new Chart(document.getElementById("languesParle"), {
			type: "bar",
			data: {
				labels: dataLangue.map((row) => row.title),
				datasets: [{
					label: "",
					axis: "y",
					// barPercentage: 1,
					// barThickness: 20,
					// maxBarThickness: 20,
					data: dataLangue.map((row) => row.value),
					backgroundColor: dataLangue.map((row) => row.color),
					borderWidth: 0,
					// base: 0,
					// barPercentage: 0.5,
				}, ],
			},
			options: chartOptionsBar,
		})
	}
	const dataNaissance = [{ title: "Oui (84,1%)", value: 84.1, color: "#6C9EC9" }, { title: "Non (14,9%)", value: 14.9, color: "#028982" }, { title: "Préfère ne pas répondre (1%)", value: 1, color: "#b9b6b6" }, ]
	var thenaissanceQuebec = document.getElementById("naissanceQuebec")
	if (thenaissanceQuebec) {
		const naissanceQuebec = new Chart(document.getElementById("naissanceQuebec"), {
			type: "doughnut",
			data: {
				labels: dataNaissance.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataNaissance.map((row) => row.value),
					backgroundColor: dataNaissance.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}
	const dataNaissanceCanada = [{ title: "Oui (11,6%)", value: 11.6, color: "#6C9EC9" }, { title: "Non (88,4%)", value: 88.4, color: "#028982" }, ]
	var thenaissanceCanadac = document.getElementById("naissanceCanada")
	if (thenaissanceCanadac) {
		const naissanceCanada = new Chart(document.getElementById("naissanceCanada"), {
			type: "doughnut",
			data: {
				labels: dataNaissanceCanada.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataNaissanceCanada.map((row) => row.value),
					backgroundColor: dataNaissanceCanada.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}

	const dataGenre = [
	{title:'Féminin (71,3%)',value:71.3,color:'#028982'},
	{title:'Masculin (26,3%)',value:26.3,color:'#D32A92'},
	{title:'Non-binaire (0,3%)',value:0.3,color:'#6C9EC9'},
	{title:'Préfère ne pas répondre (2,1%)',value:2.1,color:'#b9b6b6'},
	];

	var thegenreRepondants = document.getElementById("genreRepondants")
	if (thegenreRepondants) {
		const genreRepondants = new Chart(document.getElementById("genreRepondants"), {
			type: "doughnut",
			data: {
				labels: dataGenre.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataGenre.map((row) => row.value),
					backgroundColor: dataGenre.map((row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}
	const dataDiplomeObtenu = [
		{title:'Aucun certificat, diplôme ou grade (2,1%)',value:2.1,color:'#6C9EC9'},
		{title:'Diplôme d\'études secondaires ou l\'équivalent (7,3%)',value:7.3,color:'#C1DDF5'},
		{title:'Certificat ou diplôme d\'apprenti ou d\'une école de métiers (4,5%)',value:4.5,color:'#028982'},
		{title:'Diplôme d\'un collège, cégep ou autre établissement non universitaire (21,1%)',value:21.1,color:'#6FBDB9'},
		{title:'Certificat ou diplôme universitaire inférieur au baccalauréat (7,6%)',value:7.6,color:'#D32A92'},
		{title:'Certificat, diplôme ou grade universitaire au niveau du baccalauréat (23,5%)',value:23.5,color:'#E494C6'},
		{title:'Certificat ou diplôme universitaire supérieur au baccalauréat (11,8%)',value:11.8,color:'#FFF44F'},
		{title:'Maîtrise ou doctorat (17,3%)',value:17.3,color:'#899B5A'},
		{title:'Préfère ne pas répondre (4,8%)',value:4.8,color:'#b9b6b6'},
	]
	var thediplomeObtenu = document.getElementById("diplomeObtenu")
	if (thediplomeObtenu) {
		const diplomeObtenu = new Chart(document.getElementById("diplomeObtenu"), {
			type: "doughnut",
			data: {
				labels: dataDiplomeObtenu.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataDiplomeObtenu.map((row) => row.value),
					backgroundColor: dataDiplomeObtenu.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}
	const dataAuEtude = [{ title: "Oui (8%)", value: 8, color: "#6C9EC9" }, { title: "Non (90%)", value: 90, color: "#028982" }, { title: "Préfère ne pas répondre (2%)", value: 2, color: "#b9b6b6" }, ]
	var theauEtude = document.getElementById("auEtude")
	if (theauEtude) {
		const auEtude = new Chart(document.getElementById("auEtude"), {
			type: "doughnut",
			data: {
				labels: dataAuEtude.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataAuEtude.map((row) => row.value),
					backgroundColor: dataAuEtude.map((row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}
	const dataSecteurActiviteTravail = [
		{title:'Préfère ne pas répondre (6,9%)',value:6.9,color:'#b9b6b6'},
		{title:'Services d\'enseignement (18%)',value:18,color:'#C1DDF5'},
		{title:'Autre (8,3%)',value:8.3,color:'#D32A92'},
		{title:'Retraite (13,8%)',value:13.8,color:'#E494C6'},
		{title:'Arts, spectacles et loisirs (8,7%)',value:8.7,color:'#028982'},
		{title:'Services d\'hébergement et de restauration (1%)',value:1,color:'#6FBDB9'},
		{title:'Services publics (5,2%)',value:5.2,color:'#6C9EC9'},
		{title:'Services professionnels, scientifiques et techniques (5,9%)',value:5.9,color:'#CBD2B8'},
		{title:'Commerce de détail (1,7%)',value:1.7,color:'#899B5A'},
		{title:'Agriculture, foresterie, pêche et chasse (2,1%)',value:2.1,color:'#C1DDF5'},
		{title:'Soins de santé et assistance sociale (9,7%)',value:9.7,color:'#FF9DC2'},
		{title:'Administrations publiques (5,5%)',value:5.5,color:'#FDD6E4'},
		{title:'Gestion de sociétés et d\'entreprises (0,7%)',value:0.7,color:'#4EA8A3'},
		{title:'Services administratifs\, service de soutien (1,7%)',value:1.7,color:'#AEDDDB'},
		{title:'Finance et assurances (2,4%)',value:2.4,color:'#131313'},
		{title:'Industrie de l\'information et industrie culturelle (3,1%)',value:3.1,color:'#b889e9'},
		{title:'Extraction minière\, pétrole et gaz (0,7%)',value:0.7,color:'#8EB9DE'},
		{title:'Construction (2,1%)',value:2.1,color:'#DCEBF8'},
		{title:'Transport et entreposage (0,7%)',value:0.7,color:'#4285f4'},
		{title:'Fabrication (1%)',value:1,color:'#D32A92'},
		{title:'Services immobiliers (0,5%)',value:0.5,color:'#DAE0CC'},
		{title:'Commerce de gros (0,3%)',value:0.3,color:'#6C9EC9'},


	 ]
	var thesecteurActiviteTravail = document.getElementById("secteurActiviteTravail")
	if (thesecteurActiviteTravail) {
		const secteurActiviteTravail = new Chart(document.getElementById("secteurActiviteTravail"), {
			type: "doughnut",
			data: {
				labels: dataSecteurActiviteTravail.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataSecteurActiviteTravail.map(
						(row) => row.value),
					backgroundColor: dataSecteurActiviteTravail.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}
	const dataSalaire = [{ title: "26 000$ et moins (10%)", value: 10, color: "#6C9EC9" }, { title: "26 000$ à 35 000$ (9,3%)", value: 9.3, color: "#C1DDF5" }, { title: "35 000$ à 58 000$ (19%)", value: 19, color: "#028982" }, { title: "58 000$ à 77 000$ (12,5%)", value: 12.5, color: "#6FBDB9" }, { title: "77 000$ à 98 000$ (18%)", value: 18, color: "#D32A92" }, { title: "98 000$ à 142 000$ (8%)", value: 8, color: "#E494C6" }, { title: "142 000$ et plus (1,7%)", value: 1.7, color: "#FFF44F" }, {
		title: "Préfère ne pas répondre (21,5%)",
		value: 21.5,
		color: "#b9b6b6",
	}, ]
	var thesalaireRepondants = document.getElementById("salaireRepondants")
	if (thesalaireRepondants) {
		const salaireRepondants = new Chart(document.getElementById("salaireRepondants"), {
			type: "doughnut",
			data: {
				labels: dataSalaire.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataSalaire.map((row) => row.value),
					backgroundColor: dataSalaire.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}
	const dataVisiteGroupe = [{ title: "En famille (38,8%)", value: 38.8, color: "#6C9EC9" }, { title: "Entre ami-es (28,7%)", value: 28.7, color: "#028982" }, { title: "Seul-e (31,5%)", value: 31.5, color: "#C1DDF5" }, { title: "Préfère ne pas répondre (1%)", value: 1.0, color: "#b9b6b6" }, ]
	var thevisiteGroupe = document.getElementById("visiteGroupe")
	if (thevisiteGroupe) {
		const visiteGroupe = new Chart(document.getElementById("visiteGroupe"), {
			type: "doughnut",
			data: {
				labels: dataVisiteGroupe.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataVisiteGroupe.map((row) => row.value),
					backgroundColor: dataVisiteGroupe.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}
	const dataNbActivite = [{ title: "Oui (55,7%)", value: 55.7, color: "#6C9EC9" }, { title: "Non (36,7%)", value: 36.7, color: "#028982" }, {
		title: "Préfère ne pas répondre (7,6%)",
		value: 7.6,
		color: "#b9b6b6",
	}, ]
	var thenombreActivite = document.getElementById("nombreActivite")
	if (thenombreActivite) {
		const nombreActivite = new Chart(document.getElementById("nombreActivite"), {
			type: "doughnut",
			data: {
				labels: dataNbActivite.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataNbActivite.map((row) => row.value),
					backgroundColor: dataNbActivite.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}


	const dataVoix = [
	{title:'Non (18,2%)',value:18.2, color:'#6C9EC9'},
	{title:'Oui (61,3%)',value:61.3, color:'#C1DDF5'},
	{title:'Préfère ne pas répondre (20,5%)',value:20.5, color:'#b9b6b6'},
	];

	var theVoix = document.getElementById("voix")
	if (theVoix) {
		const voix = new Chart(document.getElementById("voix"), {
			type: "doughnut",
			data: {
				labels: dataVoix.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataVoix.map((row) => row.value),
					backgroundColor: dataVoix.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}

	const dataPratiqueArtistique = [
	{title:'Non (33,2%)',value:33.2, color:'#6C9EC9'},
	{title:'Oui (62%)',value:62, color:'#D32A92'},
	{title:'Préfère ne pas répondre (4,8%)',value:4.8, color:'#b9b6b6'},
	];


	var thepratiqueArtistique = document.getElementById("pratiqueArtistique")
	if (thepratiqueArtistique) {
		const pratiqueArtistique = new Chart(document.getElementById("pratiqueArtistique"), {
			type: "doughnut",
			data: {
				labels: dataPratiqueArtistique.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataPratiqueArtistique.map((row) => row.value),
					backgroundColor: dataPratiqueArtistique.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}

	const datasAccessibiliteCulturelle = [
	{title:'Les lieux culturels sont trop éloignés de chez toi (46,3%)',value:46.3, color:'#6C9EC9'},
	{title:'L\'offre culturelle ne correspond pas à tes besoins et tes intérêts (30,9%)',value:30.9, color:'#028982'},
	{title:'Le manque de temps ou les horaires non-adaptées (46,4%)',value:46.4, color:'#D32A92'},
	{title:'Le manque d\'information sur les activités disponibles (55,7%)',value:55.7, color:'#FFF44F'},
	{title:'Les coûts trop élevés (57,8%)',value:57.8, color:'#AEDDDB'},
	];

	var theaccessibiliteCulturelle = document.getElementById("accessibiliteCulturelle")
	if (theaccessibiliteCulturelle) {
		const accessibiliteCulturelle = new Chart(document.getElementById("accessibiliteCulturelle"), {
			type: "bar",
			data: {
				labels: datasAccessibiliteCulturelle.map((row) => row.title),
				datasets: [{
					label: "",
					axis: "y",
					data: datasAccessibiliteCulturelle.map((row) => row.value),
					backgroundColor: datasAccessibiliteCulturelle.map((row) => row.color),
					borderWidth: 0,
				}, ],
			},
			options: chartOptionsBar,
		})
	}




	const dataActivitePratique = [
	{title:'Musique (45,9%)',value:45.9,color:'#028982'},
	{title:'Dessin (45,6%)',value:45.6,color:'#6FBDB9'},
	{title:'Danse (27,3%)',value:27.3,color:'#D32A92'},
	{title:'Théâtre (17%)',value:17.0,color:'#E494C6'},
	{title:'Cirque (3,1%)',value:3.1,color:'#6C9EC9'},
	{title:'Art de la parole (16,7%)',value:16.7,color:'#C1DDF5'},
	{title:'Création littéraire (31,9%)',value:31.9,color:'#FFF44F'},
	{title:'Graffiti et murales (4,1%)',value:4.1,color:'#FCF6A7'},
	{title:'Photographie (24,5%)',value:24.5,color:'#899B5A'},
	{title:'Création numérique (17%)',value:17.0,color:'#CBD2B8'},
	{title:'Sculpture\, peinture\, arts textiles\, arts d\'impression (20,8%)',value:20.8,color:'#AEDDDB'},
	{title:'Artisanat (13,6%)',value:13.6,color:'#FCFAD8'},
	{title:'Autre (8,5%)',value:8.5,color:'#FF9DC2'},
	{title:'Aucune (10,5%)',value:10.5,color:'#4285f4'},
	{title:'Sport (4,1%)',value:4.1,color:'#b889e9'},
	{title:'Ne pas répondre (0,3%)',value:0.3,color:'#b9b6b6'},
	];


	var theactivitePratique = document.getElementById("activitePratique")
	if (theactivitePratique) {
		const activitePratique = new Chart(document.getElementById("activitePratique"), {
			type: "bar",
			data: {
				labels: dataActivitePratique.map((row) => row.title),
				datasets: [{
					label: "",
					axis: "y",
					data: dataActivitePratique.map((row) => row.value),
					backgroundColor: dataActivitePratique.map((row) => row.color),
					borderWidth: 0,
				}, ],
			},
			options: chartOptionsBar50,
		})
	}



	const dataAutreSport = [
	{title:'Sport en général (40%)',value:40, color:'#6C9EC9'},
	{title:'Karaté traditionnel (8,6%)',value:8.6, color:'#C1DDF5'},
	{title:'Hockey\, patinage (25,7%)',value:25.7, color:'#028982'},
	{title:'Basket\, soccer\, volleyball (17,1%)',value:17.1, color:'#6FBDB9'},
	{title:'Zumba (8,6%)',value:8.6, color:'#D32A92'},
	];


	var theaautreSport = document.getElementById("autreSport")
	if (theaautreSport) {
		const autreSport = new Chart(document.getElementById("autreSport"), {
			type: "doughnut",
			data: {
				labels: dataAutreSport.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataAutreSport.map((row) => row.value),
					backgroundColor: dataAutreSport.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}

	const dataActiviteDiverse = [
	{title:'Cuisine (11,7%)',value:11.7, color:'#6C9EC9'},
	{title:'Décoration (11,5%)',value:11.5, color:'#028982'},
	{title:'Design (7,7%)',value:7.7, color:'#D32A92'},
	{title:'Dormir (11,5%)',value:11.5, color:'#E494C6'},
	{title:'Mannequinat (11,5%)',value:11.5, color:'#FFF44F'},
	{title:'Montage\, jeux vidéo (11,6%)',value:11.6, color:'#FCF6A7'},
	{title:'Divers (23%)',value:23, color:'#FF9DC2'},
	{title:'Science (11,5%)',value:11.5, color:'#FDD6E4'},
	];



	var theactiviteDiverse = document.getElementById("activiteDiverse")
	if (theactiviteDiverse) {
		const activiteDiverse = new Chart(document.getElementById("activiteDiverse"), {
			type: "doughnut",
			data: {
				labels: dataActiviteDiverse.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataActiviteDiverse.map((row) => row.value),
					backgroundColor: dataActiviteDiverse.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}

	const dataCombienActivite = [
	{title:'0 activité (10%)',value:10,color:'#6C9EC9'},
	{title:'1 activité (19,5%)',value:19.5,color:'#C1DDF5'},
	{title:'2 activités (15,7%)',value:15.7,color:'#D32A92'},
	{title:'3 activités (22,7%)',value:22.7,color:'#FDD6E4'},
	{title:'4 activités (13,6%)',value:13.6,color:'#028982'},
	{title:'5 activités (7,9%)',value:7.9,color:'#4285f4'},
	{title:'6 activités (5,4%)',value:5.4,color:'#899B5A'},
	{title:'7 activités (3,6%)',value:3.6,color:'#CBD2B8'},
	{title:'8 activités (1%)',value:1,color:'#6FBDB9'},
	{title:'9 activités (0,3%)',value:0.3,color:'#D32A92'},
	{title:'12 activités (0,3%)',value:0.3,color:'#FFF44F'},
	];


	var thecombienActivite = document.getElementById("combienActivite")
	if (thecombienActivite) {
		const combienActivite = new Chart(document.getElementById("combienActivite"), {
			type: "doughnut",
			data: {
				labels: dataCombienActivite.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataCombienActivite.map((row) => row.value),
					backgroundColor: dataCombienActivite.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}



	const dataDecouvertActivite = [
	{title:'Par des cours (33,6%)',value:33.6,color:'#6C9EC9'},
	{title:'À l\'école (54,5%)',value:54.5,color:'#C1DDF5'},
	{title:'Avec des membres de ma famille (41,8%)',value:41.8,color:'#D32A92'},
	{title:'Avec mes ami.e.s (31,5%)',value:31.5,color:'#E494C6'},
	{title:'En ligne (26,7%)',value:26.7,color:'#028982'},
	{title:'Par moi-même (63%)',value:63.0,color:'#AEDDDB'},
	{title:'Autre (1%)',value:1.0,color:'#FFF44F'},
	];

	var theadecouvertActivite = document.getElementById("decouvertActivite")
	if (theadecouvertActivite) {
		const decouvertActivite = new Chart(theadecouvertActivite, {
			type: "bar",
			data: {
				labels: dataDecouvertActivite.map((row) => row.title),
				datasets: [{
					label: "",
					axis: "y",
					data: dataDecouvertActivite.map((row) => row.value),
					backgroundColor: dataDecouvertActivite.map((row) => row.color),
					borderWidth: 0,
				}, ],
			},
			options: chartOptionsBar,
		})
	}

	const dataPointContact = [
	{title:'Aucun point de contact nommé (10,7%)',value:10.7, color:'#6C9EC9'},
	{title:'1 point de contact (18,9%)',value:18.9, color:'#C1DDF5'},
	{title:'2 points de contact (22,3%)',value:22.3, color:'#D32A92'},
	{title:'3 points de contact (21,6%)',value:21.6, color:'#E494C6'},
	{title:'4 points de contact (13,4%)',value:13.4, color:'#028982'},
	{title:'5 points de contact (8,3%)',value:8.3, color:'#AEDDDB'},
	{title:'6 points de contact (4,5%)',value:4.5, color:'#899B5A'},
	{title:'7 points de contact (0,3%)',value:0.3, color:'#FFF44F'},
	];

	var thecdataPointContact = document.getElementById("pointContact")
	if (thecdataPointContact) {
		const pointContact = new Chart(thecdataPointContact, {
			type: "doughnut",
			data: {
				labels: dataPointContact.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataPointContact.map((row) => row.value),
					backgroundColor: dataPointContact.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}

	const dataAvecQui = [
	{title:'Avec des membres de ma famille (24,6%)',value:24.6,color:'#6C9EC9'},
	{title:'Avec mes ami.e.s (52,9%)',value:52.9,color:'#C1DDF5'},
	{title:'Avec d\’autres passionné.e.s (33,1%)',value:33.1,color:'#028982'},
	{title:'Auprès d’un public (16,4%)',value:16.4,color:'#6FBDB9'},
	{title:'En ligne (6,8%)',value:6.8,color:'#D32A92'},
	{title:'Je les fais seul.e (63,1%)',value:63.1,color:'#E494C6'},
	{title:'Professeurs (1%)',value:1,color:'#4285f4'},
	{title:'Camarades de classe (2%)',value:2,color:'#b889e9'},
	{title:'Autre (0,3%)',value:0.3,color:'#899B5A'},
	{title:'Préfère ne pas répondre (0,3%)',value:0.3,color:'#b9b6b6'},
	];

	var theavecQui = document.getElementById("avecQui")
	if (theavecQui) {
		const avecQui = new Chart(theavecQui, {
			type: "bar",
			data: {
				labels: dataAvecQui.map((row) => row.title),
				datasets: [{
					label: "",
					axis: "y",
					data: dataAvecQui.map((row) => row.value),
					backgroundColor: dataAvecQui.map((row) => row.color),
					borderWidth: 0,
				}, ],
			},
			options: chartOptionsBar70,
		})
	}

	const dataActiviteOu = [
	{title:'Dans ma chambre ou un espace chez moi (72,4%)',value:72.4,color:'#028982'},
	{title:'Chez mes ami.e.s (18,4%)',value:18.4,color:'#6FBDB9'},
	{title:'Dans un lieu dédié à la pratique (39,9%)',value:39.9,color:'#D32A92'},
	{title:'En ligne (9,2%)',value:9.2,color:'#E494C6'},
	{title:'À l\’école\, au cégep ou à l\’université (47,8%)',value:47.8,color:'#6C9EC9'},
	{title:'Dans des lieux publics (16,7%)',value:16.7,color:'#C1DDF5'},
	{title:'Au travail (0,7%)',value:0.7,color:'#b889e9'},
	{title:'A l\’extérieur (dans la nature) (0,7%)',value:0.7,color:'#4285f4'},
	{title:'En représentation\, en spectacle (29%)',value:29,color:'#899B5A'},
	{title:'Autre (1,3%)',value:1.3,color:'#AEDDDB'},
	{title:'Préfère ne pas répondre (0,3%)',value:0.3,color:'#b9b6b6'},
	];

	var theactiviteOu = document.getElementById("activiteOu")
	if (theactiviteOu) {
		const activiteOu = new Chart(theactiviteOu, {
			type: "bar",
			data: {
				labels: dataActiviteOu.map((row) => row.title),
				datasets: [{
					label: "",
					axis: "y",
					data: dataActiviteOu.map((row) => row.value),
					backgroundColor: dataActiviteOu.map((row) => row.color),
					borderWidth: 0,
				}, ],
			},
			options: chartOptionsBar75,
		})
	}


	const dataActiviteProcure = [
	{title:'Rencontrer des personnes (35,5%)',value:35.5, color:'#6C9EC9'},
	{title:'Me défouler (44,4%)',value:44.4, color:'#C1DDF5'},
	{title:'Exprimer mes émotions\, mes idées (59,4%)',value:59.4, color:'#028982'},
	{title:'Me sentir en confiance (39,2%)',value:39.2, color:'#6FBDB9'},
	{title:'M\'améliorer (47,1%)',value:47.1, color:'#D32A92'},
	{title:'Relaxer\, gérer le stress\, l\'anxiété (58,7%)',value:58.7, color:'#E494C6'},
	{title:'Améliorer ma concentration (28,6%)',value:28.6, color:'#FFF44F'},
	{title:'Développer mon imagination (50,8%)',value:50.8, color:'#FCF6A7'},
	{title:'Me sentir bien dans mon corps (32,7%)',value:32.7, color:'#899B5A'},
	{title:'Passer le temps\, me divertir (67,6%)',value:67.6, color:'#CBD2B8'},
	{title:'Autre (2,7%)',value:2.7, color:'#FF9DC2'},
	];

	var theactiviteProcure = document.getElementById("activiteProcure")
	if (theactiviteProcure) {
		const activiteProcure = new Chart(theactiviteProcure, {
			type: "bar",
			data: {
				labels: dataActiviteProcure.map((row) => row.title),
				datasets: [{
					label: "",
					axis: "y",
					data: dataActiviteProcure.map((row) => row.value),
					backgroundColor: dataActiviteProcure.map((row) => row.color),
					borderWidth: 0,
				}, ],
			},
			options: chartOptionsBar,
		})
	}


	const dataAimeFaireActivite = [
	{title:'Concerts (55,3%)',value:55.3,color:'#D32A92'},
	{title:'Pièces de théâtre (36,9%)',value:36.9,color:'#E494C6'},
	{title:'Spectacles de danse (33,1%)',value:33.1,color:'#899B5A'},
	{title:'Spectacles de littérature orale (poésie, conte, slam, etc.) (8,9%)',value:8.9,color:'#CBD2B8'},
	{title:'Spectacles d\'humour (42,6%)',value:42.6,color:'#6C9EC9'},
	{title:'Spectacles de cirque (15,3%)',value:15.3,color:'#C1DDF5'},
	{title:'Films au cinéma (64,5%)',value:64.5,color:'#FFF44F'},
	{title:'Expositions artistiques (musées\, galeries\, etc.) (31,4%)',value:31.4,color:'#FCF6A7'},
	{title:'Visionnage de film ou de séries en ligne (63,5%)',value:63.5,color:'#028982'},
	{title:'Visionnage de contenus culturels sur les médias sociaux (39,6%)',value:39.6,color:'#6FBDB9'},
	{title:'Écoute de musique (84,3%)',value:84.3,color:'#FF9DC2'},
	{title:'Écoute de balados et de livres audio (35,1%)',value:35.1,color:'#FDD6E4'},
	{title:'Lecture (roman\, essai\, bande dessinée\, etc.) (49,1%)',value:49.1,color:'#DCEBF8'},
	{title:'Jeux vidéos (35,5%)',value:35.5,color:'#b889e9'},
	{title:'Autre (2%)',value:2,color:'#4285f4'},
	{title:'Préfère ne pas répondre (0,7%)',value:0.7,color:'#b9b6b6'},
	{title:'Aucune (0,3%)',value:0.3,color:'#DAE0CC'},
	];

	var theaimeFaireActivite = document.getElementById("aimeFaireActivite")
	if (theaimeFaireActivite) {
		const aimeFaireActivite = new Chart(theaimeFaireActivite, {
			type: "bar",
			data: {
				labels: dataAimeFaireActivite.map((row) => row.title),
				datasets: [{
					label: "",
					axis: "y",
					data: dataAimeFaireActivite.map((row) => row.value),
					backgroundColor: dataAimeFaireActivite.map((row) => row.color),
					borderWidth: 0,
				}, ],
			},
			options: chartOptionsBar90,
		})
	}


	const datasCombienActiviteCulturelle = [
	{title:'1 activité (6,5%)',value:6.5, color:'#D32A92'},
	{title:'2 activités (6,8%)',value:6.8, color:'#E494C6'},
	{title:'3 activités (10,2%)',value:10.2, color:'#899B5A'},
	{title:'4 activités (9,6%)',value:9.6, color:'#CBD2B8'},
	{title:'5 activités (13,7%)',value:13.7, color:'#6C9EC9'},
	{title:'6 activités (11,7%)',value:11.7, color:'#C1DDF5'},
	{title:'7 activités (8,5%)',value:8.5, color:'#FFF44F'},
	{title:'8 activtés (8,2%)',value:8.2, color:'#FCF6A7'},
	{title:'9 activités (9,9%)',value:9.9, color:'#028982'},
	{title:'10 activités (4,1%)',value:4.1, color:'#6FBDB9'},
	{title:'11 activités (4,1%)',value:4.1, color:'#FF9DC2'},
	{title:'12 activités (3,4%)',value:3.4, color:'#FDD6E4'},
	{title:'13 activités (2%)',value:2, color:'#DCEBF8'},
	{title:'14 activités (1,3%)',value:1.3, color:'#b889e9'},
	];

	var thecombienActiviteCulturelle = document.getElementById("combienActiviteCulturelle")
	if (thecombienActiviteCulturelle) {
		const combienActiviteCulturelle = new Chart(thecombienActiviteCulturelle, {
			type: "doughnut",
			data: {
				labels: datasCombienActiviteCulturelle.map((row) => row.title),
				datasets: [{
					label: "",
					data: datasCombienActiviteCulturelle.map((row) => row.value),
					backgroundColor: datasCombienActiviteCulturelle.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}


	const dataActiviteCulturelleProcure = [
	{title:'Trouver ma communauté (28,7%)',value:28.7, color:'#D32A92'},
	{title:'Découvrir d\'autres formes d\'expression (33,8%)',value:33.8, color:'#E494C6'},
	{title:'Passer un bon moment\, me divertir (86%)',value:86.0, color:'#899B5A'},
	{title:'Améliorer ma concentration (21,4%)',value:21.4, color:'#CBD2B8'},
	{title:'Relaxer\, m\'apaiser (63,9%)',value:63.9, color:'#6C9EC9'},
	{title:'Apprendre de nouvelles choses (63,4%)',value:63.4, color:'#C1DDF5'},
	{title:'Réfléchir (42,3%)',value:42.3, color:'#FFF44F'},
	{title:'Me motiver (39,6%)',value:39.6, color:'#FCF6A7'},
	{title:'Encourager à m\'exprimer (31,7%)',value:31.7, color:'#028982'},
	{title:'Donner envie de partager mes goûts (22,8%)',value:22.8, color:'#6FBDB9'},
	{title:'Rencontrer des nouvelles personnes (29,7%)',value:29.7, color:'#FF9DC2'},
	{title:'Gérer le stress\, l\'anxiété (43,3%)',value:43.3, color:'#FDD6E4'},
	{title:'Autre (2%)',value:2, color:'#DCEBF8'},
	{title:'Préfère ne pas répondre (1,7%)',value:1.7, color:'#b9b6b6'},
	];

	var theactiviteCulturelleProcure = document.getElementById("activiteCulturelleProcure")
	if (theactiviteCulturelleProcure) {
		const activiteCulturelleProcure = new Chart(theactiviteCulturelleProcure, {
			type: "bar",
			data: {
				labels: dataActiviteCulturelleProcure.map((row) => row.title),
				datasets: [{
					label: "",
					axis: "y",
					data: dataActiviteCulturelleProcure.map((row) => row.value),
					backgroundColor: dataActiviteCulturelleProcure.map((row) => row.color),
					borderWidth: 0,
				}, ],
			},
			options: chartOptionsBar,
		})
	}

	const dataCommentInformeActiviteCulturelle = [
	{title:'Par mes ami.e.s (59%)',value:59, color:'#D32A92'},
	{title:'Par ma famille (49,5%)',value:49.5, color:'#E494C6'},
	{title:'Par l\'école\, le cégep ou l\'université (47,4%)',value:47.4, color:'#899B5A'},
	{title:'Par des affiches\, brochures (23,9%)',value:23.9, color:'#CBD2B8'},
	{title:'TikTok (57,3%)',value:57.3, color:'#6C9EC9'},
	{title:'Snapchat (13,6%)',value:13.6, color:'#C1DDF5'},
	{title:'Facebook (32,1%)',value:32.1, color:'#FFF44F'},
	{title:'Instagram (58%)',value:58, color:'#FCF6A7'},
	{title:'Sites spécialisés (24,9%)',value:24.9, color:'#028982'},
	{title:'Télévision (34,1%)',value:34.1, color:'#6FBDB9'},
	{title:'Radio (20,1%)',value:20.1, color:'#FF9DC2'},
	{title:'Journaux\, magazines (14%)',value:14.0, color:'#FDD6E4'},
	{title:'Autre (3,1%)',value:3.1, color:'#DCEBF8'},
	{title:'Préfère ne pas répondre (5,1%)',value:5.1, color:'#b9b6b6'},
	];

	var thecommentInformeActiviteCulturelle = document.getElementById("commentInformeActiviteCulturelle")
	if (thecommentInformeActiviteCulturelle) {
		const commentInformeActiviteCulturelle = new Chart(thecommentInformeActiviteCulturelle, {
			type: "bar",
			data: {
				labels: dataCommentInformeActiviteCulturelle.map((row) => row.title),
				datasets: [{
					label: "",
					axis: "y",
					data: dataCommentInformeActiviteCulturelle.map((row) => row.value),
					backgroundColor: dataCommentInformeActiviteCulturelle.map((row) => row.color),
					borderWidth: 0,
				}, ],
			},
			options: chartOptionsBar,
		})
	}

	const dataPartageDecouverte = [
	{title:'Oui (66,4%)',value:66.4, color:'#6C9EC9'},
	{title:'Non (29,1%)',value:29.1, color:'#D32A92'},
	{title:'Préfère ne pas répondre (4,5%)',value:4.5, color:'#b9b6b6'},
	];

	var thepartageDecouverte = document.getElementById("partageDecouverte")
	if (thepartageDecouverte) {
		const partageDecouverte = new Chart(thepartageDecouverte, {
			type: "doughnut",
			data: {
				labels: dataPartageDecouverte.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataPartageDecouverte.map((row) => row.value),
					backgroundColor: dataPartageDecouverte.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}



	const dataAvecQuiPartageCulturelle = [
	{title:'Avec des membres de ma famille (50,2%)',value:50.2, color:'#D32A92'},
	{title:'Avec des ami.e.s (61,8%)',value:61.8, color:'#E494C6'},
	{title:'Avec d\'autres passionné.e.s (26,3%)',value:26.3, color:'#899B5A'},
	{title:'Autre (1,7%)',value:1.7, color:'#CBD2B8'},
	{title:'Préfère ne pas répondre (0,3%)',value:0.3, color:'#6C9EC9'},
	];

	var theavecQuiPartageCulturelle = document.getElementById("avecQuiPartageCulturelle")
	if (theavecQuiPartageCulturelle) {
		const avecQuiPartageCulturelle = new Chart(theavecQuiPartageCulturelle, {
			type: "bar",
			data: {
				labels: dataAvecQuiPartageCulturelle.map((row) => row.title),
				datasets: [{
					label: "",
					axis: "y",
					data: dataAvecQuiPartageCulturelle.map((row) => row.value),
					backgroundColor: dataAvecQuiPartageCulturelle.map((row) => row.color),
					borderWidth: 0,
				}, ],
			},
			options: chartOptionsBar70,
		})
	}

	const dataCommentPartageDecouverteCulturelle = [
	{title:'En discutant en ligne (33,8%)',value:33.8,color:'#D32A92'},
	{title:'En discutant en personne (62,8%)',value:62.8,color:'#E494C6'},
	{title:'En envoyant des liens numériques (25,6%)',value:25.6,color:'#899B5A'},
	{title:'En offrant des objets culturels ou des places de spectacle (10,6%)',value:10.6,color:'#CBD2B8'},
	{title:'En prêtant des objets culturels (2,8%)',value:2.8,color:'#6C9EC9'},
	{title:'En créant et partageant des listes de suggestions (6,5%)',value:6.5,color:'#C1DDF5'},
	{title:'Autre (1,4%)',value:1.4,color:'#6FBDB9'},

	];

	var thecommentPartageDecouverteCulturelle = document.getElementById("commentPartageDecouverteCulturelle")
	if (thecommentPartageDecouverteCulturelle) {
		const commentPartageDecouverteCulturelle = new Chart(thecommentPartageDecouverteCulturelle, {
			type: "bar",
			data: {
				labels: dataCommentPartageDecouverteCulturelle.map((row) => row.title),
				datasets: [{
					label: "",
					axis: "y",
					data: dataCommentPartageDecouverteCulturelle.map((row) => row.value),
					backgroundColor: dataCommentPartageDecouverteCulturelle.map((row) => row.color),
					borderWidth: 0,
				}, ],
			},
			options: chartOptionsBar,
		})
	}


	const dataPlateformeCulturelleFavorite = [
	{title:'YouTube (78,9%)',value:78.9, color:'#D32A92'},
	{title:'Spotify (64,5%)',value:64.5, color:'#E494C6'},
	{title:'Soundcloud (2,8%)',value:2.8, color:'#899B5A'},
	{title:'Twitch (7,5%)',value:7.5, color:'#CBD2B8'},
	{title:'Apple music (20,9%)',value:20.9, color:'#6C9EC9'},
	{title:'Apple podcast (5,5%)',value:5.5, color:'#C1DDF5'},
	{title:'Ohdio (9,9%)',value:9.9, color:'#FFF44F'},
	{title:'Tou.tv (21,8%)',value:21.8, color:'#FCF6A7'},
	{title:'Netflix (77,5%)',value:77.5, color:'#028982'},
	{title:'Crave (16%)',value:16.0, color:'#6FBDB9'},
	{title:'Disney Plus (50,8%)',value:50.8, color:'#FF9DC2'},
	{title:'Prime (35,5%)',value:35.5, color:'#FDD6E4'},
	{title:'Apple TV (8,5%)',value:8.5, color:'#DCEBF8'},
	{title:'TikTok (2,4%)',value:2.4, color:'#b889e9'},
	{title:'Aucune (1%)',value:1, color:'#4285f4'},
	{title:'Autre (10,3%)',value:10.3, color:'#DAE0CC'},
	{title:'Préfère ne pas répondre (1,4%)',value:1.4, color:'#b9b6b6'},
	];

	var theplateformeCulturelleFavorite = document.getElementById("plateformeCulturelleFavorite")
	if (theplateformeCulturelleFavorite) {
		const plateformeCulturelleFavorite = new Chart(theplateformeCulturelleFavorite, {
			type: "bar",
			data: {
				labels: dataPlateformeCulturelleFavorite.map((row) => row.title),
				datasets: [{
					label: "",
					axis: "y",
					data: dataPlateformeCulturelleFavorite.map((row) => row.value),
					backgroundColor: dataPlateformeCulturelleFavorite.map((row) => row.color),
					borderWidth: 0,
				}, ],
			},
			options: chartOptionsBar,
		})
	}

	const dataCombienPlateformeUtilise = [
	{title:'0 plateforme culturelle (1,4%)',value:1.4, color:'#D32A92'},
	{title:'1 plateforme culturelle (7,5%)',value:7.5, color:'#E494C6'},
	{title:'2 plateformes culturelles (10,3%)',value:10.3, color:'#899B5A'},
	{title:'3 plateformes culturelles (19,8%)',value:19.8, color:'#CBD2B8'},
	{title:'4 plateformes culturelles (21,5%)',value:21.5, color:'#6C9EC9'},
	{title:'5 plateformes culturelles (18,4%)',value:18.4, color:'#C1DDF5'},
	{title:'6 plateformes culturelles (9,2%)',value:9.2, color:'#FFF44F'},
	{title:'7 plateformes culturelles (7,2%)',value:7.2, color:'#FCF6A7'},
	{title:'8 plateformes culturelles (2%)',value:2, color:'#028982'},
	{title:'9 plateformes culturelles (1,7%)',value:1.7, color:'#6FBDB9'},
	{title:'10 plateformes culturelles (0,3%)',value:0.3, color:'#FF9DC2'},
	{title:'11 plateformes culturelles (0,7%)',value:0.7, color:'#FDD6E4'},
	];

	var thecombienPlateformeUtilise = document.getElementById("combienPlateformeUtilise")
	if (thecombienPlateformeUtilise) {
		const combienPlateformeUtilise = new Chart(thecombienPlateformeUtilise, {
			type: "doughnut",
			data: {
				labels: dataCombienPlateformeUtilise.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataCombienPlateformeUtilise.map((row) => row.value),
					backgroundColor: dataCombienPlateformeUtilise.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}

	const dataMediasSociauxFavoris = [
	{title:'TikTok (68,6%)',value:68.6, color:'#D32A92'},
	{title:'Snapchat (54,6%)',value:54.6, color:'#E494C6'},
	{title:'Instagram (78,1%)',value:78.1, color:'#899B5A'},
	{title:'Facebook (31%)',value:31, color:'#CBD2B8'},
	{title:'Reddit (5,1%)',value:5.1, color:'#6C9EC9'},
	{title:'X (ex-Twitter) (4,7%)',value:4.7, color:'#C1DDF5'},
	{title:'Pinterest (47,8%)',value:47.8, color:'#FFF44F'},
	{title:'BeReal (22,2%)',value:22.2, color:'#FCF6A7'},
	{title:'Aucun (2,7%)',value:2.7, color:'#028982'},
	{title:'Autres (5,8%)',value:5.8, color:'#6FBDB9'},
	{title:'Préfère ne pas répondre (1%)',value:1, color:'#b9b6b6'},
	];

	var themediasSociauxFavoris = document.getElementById("mediasSociauxFavoris")
	if (themediasSociauxFavoris) {
		const mediasSociauxFavoris = new Chart(themediasSociauxFavoris, {
			type: "bar",
			data: {
				labels: dataMediasSociauxFavoris.map((row) => row.title),
				datasets: [{
					label: "",
					axis: "y",
					data: dataMediasSociauxFavoris.map((row) => row.value),
					backgroundColor: dataMediasSociauxFavoris.map((row) => row.color),
					borderWidth: 0,
				}, ],
			},
			options: chartOptionsBar,
		})
	}


	const dataCombienMediaSociaux = [
	{title:'1 média social (12,7%)',value:12.7, color:'#D32A92'},
	{title:'2 médias sociaux (19,5%)',value:19.5, color:'#E494C6'},
	{title:'3 médias sociaux (27,1%)',value:27.1, color:'#899B5A'},
	{title:'4 médias sociaux (20,5%)',value:20.5, color:'#CBD2B8'},
	{title:'5 médias sociaux (16,1%)',value:16.1, color:'#6C9EC9'},
	{title:'6 médias sociaux (3,8%)',value:3.8, color:'#C1DDF5'},
	{title:'8 médias sociaux (0,3%)',value:0.3, color:'#FFF44F'},
	];

	var thecombienMediaSociaux = document.getElementById("combienMediaSociaux")
	if (thecombienMediaSociaux) {
		const combienMediaSociaux = new Chart(thecombienMediaSociaux, {
			type: "doughnut",
			data: {
				labels: dataCombienMediaSociaux.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataCombienMediaSociaux.map((row) => row.value),
					backgroundColor: dataCombienMediaSociaux.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}

	const dataApplicationCommunication =  [
	{title:'TikTok (19,4%)',value:19.4,color:'#D32A92'},
	{title:'Snapchat (62,8%)',value:62.8,color:'#E494C6'},
	{title:'Facebook Messenger (74,1%)',value:74.1,color:'#899B5A'},
	{title:'Instagram (59%)',value:59,color:'#CBD2B8'},
	{title:'WhatsApp (10,2%)',value:10.2,color:'#6C9EC9'},
	{title:'X (ex-Twitter) (0,7%)',value:0.7,color:'#C1DDF5'},
	{title:'Discord (9,9%)',value:9.9,color:'#FFF44F'},
	{title:'Telegram (1,3%)',value:1.3,color:'#FCF6A7'},
	{title:'Signal (2%)',value:2,color:'#028982'},
	{title:'Autres messageries (9,9%)',value:9.9,color:'#FF9DC2'},
	{title:'Par téléphone (0,7%)',value:0.7,color:'#FDD6E4'},
	{title:'Autre (1,3%)',value:1.3,color:'#DCEBF8'},
	{title:'Préfère ne pas répondre (1%)',value:1,color:'#b9b6b6'},

	];


	var theapplicationCommunication = document.getElementById("applicationCommunication")
	if (theapplicationCommunication) {
		const applicationCommunication = new Chart(theapplicationCommunication, {
			type: "bar",
			data: {
				labels: dataApplicationCommunication.map((row) => row.title),
				datasets: [{
					label: "",
					axis: "y",
					data: dataApplicationCommunication.map((row) => row.value),
					backgroundColor: dataApplicationCommunication.map((row) => row.color),
					borderWidth: 0,
				}, ],
			},
			options: chartOptionsBar75,
		})
	}

	const dataCombienMessagerieUtilise = [
	{title:'1 messagerie (16,2%)',value:16.2, color:'#6C9EC9'},
	{title:'2 messageries (35,7%)',value:35.7, color:'#C1DDF5'},
	{title:'3 messageries (30,6%)',value:30.6, color:'#028982'},
	{title:'4 messageries (13,1%)',value:13.1, color:'#6FBDB9'},
	{title:'5 messageries (4,1%)',value:4.1, color:'#D32A92'},
	{title:'6 messageries (0,3%)',value:0.3, color:'#E494C6'},
	];

	var thecombienMessagerieUtilise = document.getElementById("combienMessagerieUtilise")
	if (thecombienMessagerieUtilise) {
		const combienMessagerieUtilise = new Chart(thecombienMessagerieUtilise, {
			type: "doughnut",
			data: {
				labels: dataCombienMessagerieUtilise.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataCombienMessagerieUtilise.map((row) => row.value),
					backgroundColor: dataCombienMessagerieUtilise.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}

	const dataAnneeNaissance = [
	{title:'1998 (1%)', value:1,color:'#FDD6E4'},
	{title:'1999 (2,1%)', value:2.1,color:'#C1DDF5'},
	{title:'2000 (2,1%)', value:2.1,color:'#AEDDDB'},
	{title:'2001 (3,4%)', value:3.4,color:'#FDF9C5'},
	{title:'2002 (2,4%)', value:2.4,color:'#6FBDB9'},
	{title:'2003 (3,1%)', value:3.1,color:'#6C9EC9'},
	{title:'2004 (3%)', value:3,color:'#DCEBF8'},
	{title:'2005 (4,1%)', value:4.1,color:'#899B5A'},
	{title:'2006 (14,4%)', value:14.4,color:'#FFF44F'},
	{title:'2007 (28,1%)', value:28.1,color:'#028982'},
	{title:'2008 (26,7%)', value:26.7,color:'#E494C6'},
	{title:'Préfère ne pas répondre (9,6%)', value:9.6,color:'#b9b6b6'},
	];

	var theanneeNaissance = document.getElementById("anneeNaissance")
	if (theanneeNaissance) {
		const anneeNaissance = new Chart(theanneeNaissance, {
			type: "bar",
			data: {
				labels: dataAnneeNaissance.map((row) => row.title),
				datasets: [{
					label: "",
					axis: "y",
					data: dataAnneeNaissance.map((row) => row.value),
					backgroundColor: dataAnneeNaissance.map((row) => row.color),
					borderWidth: 0,
				}, ],
			},
			options: chartOptionsBar50,
		})
	}

	const dataDefinirGenre = [
	{title:'Masculin (21,2%)', value:21.2,color:'#6C9EC9'},
	{title:'Féminin (73,6%)', value:73.6,color:'#E494C6'},
	{title:'Non-binaire (1,4%)', value:1.4,color:'#FFF44F'},
	{title:'Autre (1,7%)', value:1.7,color:'#CBD2B8'},
	{title:'Préfère ne pas répondre (2,1%)', value:2.1,color:'#b9b6b6'},
	];


	var thedefinirGenree = document.getElementById("definirGenre")
	if (thedefinirGenree) {
		const definirGenre = new Chart(thedefinirGenree, {
			type: "doughnut",
			data: {
				labels: dataDefinirGenre.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataDefinirGenre.map((row) => row.value),
					backgroundColor: dataDefinirGenre.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}


	const dataLangueParleMaison =  [
	{title:'Français (98,3%)',value:98.3,color:'#6C9EC9'},
	{title:'Anglais (18,8%)',value:18.8,color:'#E494C6'},
	{title:'Espagnol (3%)',value:3,color:'#028982'},
	{title:'Autre(s) (4,4%)',value:4.1,color:'#6FBDB9'},
	];


	var thelangueParleMaison = document.getElementById("langueParleMaison")
	if (thelangueParleMaison) {
		const langueParleMaison = new Chart(thelangueParleMaison, {
			type: "bar",
			data: {
				labels: dataLangueParleMaison.map((row) => row.title),
				datasets: [{
					label: "",
					axis: "y",
					data: dataLangueParleMaison.map((row) => row.value),
					backgroundColor: dataLangueParleMaison.map((row) => row.color),
					borderWidth: 0,
				}, ],
			},
			options: chartOptionsBar,
		})
	}

	const dataAppartenanceAuchtoctone = [
	{title:'Oui (3,4%)',value:3.4, color:'#6C9EC9'},
	{title:'Non (92,8%)',value:92.8, color:'#D32A92'},
	{title:'Préfère ne pas répondre (3,8%)',value:3.8, color:'#b9b6b6'},
	];

	var theappartenanceAuchtoctone = document.getElementById("appartenanceAuchtoctone")
	if (theappartenanceAuchtoctone != undefined) {
		const combienMessagerieUtilise = new Chart(theappartenanceAuchtoctone, {
			type: "doughnut",
			data: {
				labels: dataAppartenanceAuchtoctone.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataAppartenanceAuchtoctone.map((row) => row.value),
					backgroundColor: dataAppartenanceAuchtoctone.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}



	const dataPreciseNationAutochtone = [
	{title:'Anishinabeg (Algonquins) (30%)',value:30, color:'#6C9EC9'},
	{title:'Innus (10%)',value:10, color:'#C1DDF5'},
	{title:'Inuit (10%)',value:10, color:'#028982'},
	{title:'Kanien\'kehá:ka (Mohawks) (10%)',value:10, color:'#6FBDB9'},
	{title:'Mi\'gmaq (20%)',value:20, color:'#D32A92'},
	{title:'Wolastoqiyik (Malécites) (10%)',value:10, color:'#E494C6'},
	{title:'Autre (10%)',value:10, color:'#FFF44F'},
	];

	var thepreciseNationAutochtone = document.getElementById("preciseNationAutochtone")
	if (thepreciseNationAutochtone) {
		const preciseNationAutochtone = new Chart(thepreciseNationAutochtone, {
			type: "doughnut",
			data: {
				labels: dataPreciseNationAutochtone.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataPreciseNationAutochtone.map((row) => row.value),
					backgroundColor: dataPreciseNationAutochtone.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}


	const dataGroupeMinorise = [
	{title:'Oui (16,8%)',value:16.8, color:'#6C9EC9'},
	{title:'Non (68,8%)',value:68.8, color:'#D32A92'},
	{title:'Préfère ne pas répondre (14,4%)',value:14.4, color:'#b9b6b6'},
	];

	var thegroupeMinorise = document.getElementById("groupeMinorise")
	if (thegroupeMinorise) {
		const groupeMinorise = new Chart(thegroupeMinorise, {
			type: "doughnut",
			data: {
				labels: dataGroupeMinorise.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataGroupeMinorise.map((row) => row.value),
					backgroundColor: dataGroupeMinorise.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}



	const dataQuelGroupeMinoritaire = [
	{title:'Lié à l\'immigration (22,5%)',value:22.5, color:'#6C9EC9'},
	{title:'Lié à la religion (10,2%)',value:10.2, color:'#C1DDF5'},
	{title:'Lié à la langue (16,3%)',value:16.3, color:'#028982'},
	{title:'Lié à l\'orientation sexuelle (36,8%)',value:36.8, color:'#6FBDB9'},
	{title:'Lié à l\'identité de genre (24,5%)',value:24.5, color:'#D32A92'},
	{title:'Lié à des limitations fonctionnelles (10,2%)',value:10.2, color:'#E494C6'},
	{title:'Autre (couleur de peau, neurodiversité, physique) (14,3%)',value:14.3, color:'#FFF44F'},
	{title:'Préfère ne pas répondre (0%)',value:0, color:'#b9b6b6'},
	];

	var thequelGroupeMinoritaire = document.getElementById("quelGroupeMinoritaire")
	if (thequelGroupeMinoritaire) {
		const quelGroupeMinoritaire = new Chart(thequelGroupeMinoritaire, {
			type: "bar",
			data: {
				labels: dataQuelGroupeMinoritaire.map((row) => row.title),
				datasets: [{
					label: "",
					axis: "y",
					data: dataQuelGroupeMinoritaire.map((row) => row.value),
					backgroundColor: dataQuelGroupeMinoritaire.map((row) => row.color),
					borderWidth: 0,
				}, ],
			},
			options: chartOptionsBar,
		})
	}



	const dataouHabiteTu = [
	{title:'Bas-Saint-Laurent (4,2%)',value:4.2, color:'#D32A92'},
	{title:'Laurentides (6,2%)',value:6.2, color:'#E494C6'},
	{title:'Capitale-Nationale (4,1%)',value:4.1, color:'#899B5A'},
	{title:'Montérégie (19,9%)',value:19.9, color:'#CBD2B8'},
	{title:'Montréal (14%)',value:14, color:'#6C9EC9'},
	{title:'Lanaudière (8,6%)',value:8.6, color:'#C1DDF5'},
	{title:'Centre-du-Québec (14%)',value:14, color:'#FFF44F'},
	{title:'Outaouais (3,4%)',value:3.4, color:'#FCF6A7'},
	{title:'Gaspésie–Îles-de-la-Madeleine (3,4%)',value:3.4, color:'#028982'},
	{title:'Estrie (4,8%)',value:4.8, color:'#6FBDB9'},
	{title:'Mauricie (4,1%)',value:4.1, color:'#FF9DC2'},
	{title:'Saguenay–Lac-Saint-Jean (3,1%)',value:3.1, color:'#FDD6E4'},
	{title:'Laval (2,7%)',value:2.7, color:'#DCEBF8'},
	{title:'Chaudière-Appalaches (1,4%)',value:1.4, color:'#b889e9'},
	{title:'Abitibi-Témiscamingue (0,7%)',value:0.7, color:'#4285f4'},
	{title:'Côte-Nord (0,3%)',value:0.3, color:'#DAE0CC'},
	{title:'Préfère ne pas répondre (5,1%)',value:5.1, color:'#b9b6b6'},
	];

	var theouHabitesTu = document.getElementById("ouHabitesTu")
	if (theouHabitesTu) {
		const ouHabitesTu = new Chart(theouHabitesTu, {
			type: "doughnut",
			data: {
				labels: dataouHabiteTu.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataouHabiteTu.map((row) => row.value),
					backgroundColor: dataouHabiteTu.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}

	const dataVivreAvecFamille = [
	{title:'Oui (88,7%)',value:88.7, color:'#6C9EC9'},
	{title:'Non (9,6%)',value:9.6, color:'#D32A92'},
	{title:'Préfère ne pas répondre (1,7%)',value:1.7, color:'#b9b6b6'},
	];

	var thevivreAvecFamille = document.getElementById("vivreAvecFamille")
	if (thevivreAvecFamille) {
		const vivreAvecFamille = new Chart(thevivreAvecFamille, {
			type: "doughnut",
			data: {
				labels: dataVivreAvecFamille.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataVivreAvecFamille.map((row) => row.value),
					backgroundColor: dataVivreAvecFamille.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}


	const dataPresentementEtude = [
	{title:'Oui (92,5%)',value:92.5, color:'#6C9EC9'},
	{title:'Non (6,2%)',value:6.2, color:'#D32A92'},
	{title:'Préfère ne pas répondre (1,3%)',value:1.3, color:'#b9b6b6'},
	];

	var thepresentementEtude = document.getElementById("presentementEtude")
	if (thepresentementEtude) {
		const presentementEtude = new Chart(thepresentementEtude, {
			type: "doughnut",
			data: {
				labels: dataPresentementEtude.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataPresentementEtude.map((row) => row.value),
					backgroundColor: dataPresentementEtude.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}

	const dataNiveauEtude = [
	{title:'Cégep (15,6%)',value:15.6, color:'#028982'},
	{title:'Secondaire (75,9%)',value:75.9, color:'#6FBDB9'},
	{title:'Premier cycle universitaire (8,1%)',value:8.1, color:'#D32A92'},
	{title:'Deuxième et troisième cycle universitaire (0,4%)',value:0.4, color:'#E494C6'},
	];

	var theniveauEtude = document.getElementById("niveauEtude")
	if (theniveauEtude) {
		const niveauEtude = new Chart(theniveauEtude, {
			type: "doughnut",
			data: {
				labels: dataNiveauEtude.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataNiveauEtude.map((row) => row.value),
					backgroundColor: dataNiveauEtude.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}

	const dataEmploiePresent = [
	{title:'Oui (63,7%)',value:63.7, color:'#6C9EC9'},
	{title:'Non (33,9%)',value:33.9, color:'#D32A92'},
	{title:'Préfère ne pas répondre (2,4%)',value:2.4, color:'#b9b6b6'},
	];

	var theemploiePresent = document.getElementById("emploiePresent")
	if (theemploiePresent) {
		const emploiePresent = new Chart(theemploiePresent, {
			type: "doughnut",
			data: {
				labels: dataEmploiePresent.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataEmploiePresent.map((row) => row.value),
					backgroundColor: dataEmploiePresent.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}

	const dataEmploieSecteur = [
	{title:'Soins de santé et assistance sociale (6,4%)',value:6.4, color:'#028982'},
	{title:'Services publics (27,3%)',value:27.3, color:'#6FBDB9'},
	{title:'Autre (1,8%)',value:1.8, color:'#899B5A'},
	{title:'Services d\'hébergement et de restauration (16,6%)',value:16.6, color:'#CBD2B8'},
	{title:'Commerce de détail (13,4%)',value:13.4, color:'#D32A92'},
	{title:'Agriculture\, foresterie\, pêche et chasse (5,3%)',value:5.3, color:'#E494C6'},
	{title:'Services professionnels\, scientifiques et techniques  (1,6%)',value:1.6, color:'#6C9EC9'},
	{title:'Extraction minière\, pétrole et gaz (0,5%)',value:0.5, color:'#C1DDF5'},
	{title:'Arts\, spectacles et loisirs (12,3%)',value:12.3, color:'#F8E1E9'},
	{title:'Finance et assurances (1,1%)',value:1.1, color:'#FFF44F'},
	{title:'Construction (2,1%)',value:2.1, color:'#FCF6A7'},
	{title:'Industrie de l\'information et industrie culturelle (3,2%)',value:3.2, color:'#b889e9'},
	{title:'Commerce de gros (1,6%)',value:1.6, color:'#4285f4'},
	{title:'Services d\'enseignement (2,1%)',value:2.1, color:'#FF9DC2'},
	{title:'Administrations publiques (0,5%)',value:0.5, color:'#FCC2D7'},
	{title:'Transport et entreposage (2,1%)',value:2.1, color:'#FDF9C5'},
	{title:'Fabrication (1,1%)',value:1.1, color:'#FCFAD8'},
	{title:'Services administratifs\, service de soutien (0,5%)',value:0.5, color:'#8EB9DE'},
	{title:'Gestion de sociétés et d\'entreprises (0,5%)',value:0.5, color:'#DCEBF8'},
	];

	var theemploieSecteur = document.getElementById("emploieSecteur")
	if (theemploieSecteur) {
		const emploieSecteur = new Chart(theemploieSecteur, {
			type: "doughnut",
			data: {
				labels: dataEmploieSecteur.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataEmploieSecteur.map((row) => row.value),
					backgroundColor: dataEmploieSecteur.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}


const datasetSecteurActivitePrefere = [
	{title:'Artisanat (16,6%)',value:16.6,color:'#6C9EC9'},
	{title:'Cinéma (18%)',value:18.0,color:'#C1DDF5'},
	{title:'Cuisine et gastronomie (7,6%)',value:7.6,color:'#028982'},
	{title:'Danse (17,6%)',value:17.6,color:'#6FBDB9'},
	{title:'Découverte et curiosité (18,3%)',value:18.3,color:'#D32A92'},
	{title:'Dessin\, peinture\, écriture\, photo (23,5%)',value:23.5,color:'#E494C6'},
	{title:'Expositions\, loisirs créatifs (34,3%)',value:34.3,color:'#FFF44F'},
	{title:'Jardinage et horticulture (2,8%)',value:2.8,color:'#FCF6A7'},
	{title:'Jeux (2,4%)',value:2.4,color:'#899B5A'},
	{title:'Littérature\, lecture\, conte\, poésie (27,3%)',value:27.3,color:'#CBD2B8'},
	{title:'Musées\, histoire\, patrimoine\, architecture (27,7%)',value:27.7,color:'#FF9DC2'},
	{title:'Musique\, concerts\, chant\, chanson (54,3%)',value:54.3,color:'#FDD6E4'},
	{title:'Sciences\, technologies\, santé (3,5%)',value:3.5,color:'#b889e9'},
	{title:'Spectacles\, cirque\, humour (16,6%)',value:16.6,color:'#FDF9C5'},
	{title:'Spor\t, nature et plein-air (17%)',value:17.0,color:'#DAE0CC'},
	{title:'Théâtre (23,9%)',value:23.9,color:'#4285f4'},
	];



	var thesecteurActivitePrefere = document.getElementById("secteurActivitePrefere")
	if (thesecteurActivitePrefere) {
		const secteurActivitePrefere = new Chart(thesecteurActivitePrefere, {
			type: "bar",
			data: {
				labels: datasetSecteurActivitePrefere.map((row) => row.title),
				datasets: [{
					label: "",
					axis: "y",
					data: datasetSecteurActivitePrefere.map((row) => row.value),
					backgroundColor: datasetSecteurActivitePrefere.map((row) => row.color),
					borderWidth: 0,
				}, ],
			},
			options: chartOptionsBar60,
		})
	}


	const dataminorite = [
	{title:'Oui (8%)',value:8,color:'#6C9EC9'},
	{title:'Non (88,2%)',value:88.2,color:'#028982'},
	{title:'Préfère ne pas répondre (3,8%)',value:3.8,color:'#b9b6b6'},
	];

	var theminorite = document.getElementById("minorite")
	if (theminorite) {
		const minorite = new Chart(theminorite, {
			type: "doughnut",
			data: {
				labels: dataminorite.map((row) => row.title),
				datasets: [{
					label: "",
					data: dataminorite.map((row) => row.value),
					backgroundColor: dataminorite.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}

	const datalimitation = [
	{title:'Oui (5,6%)',value:5.6,color:'#6C9EC9'},
	{title:'Non (92%)',value:92,color:'#028982'},
	{title:'Préfère ne pas répondre (2,4%)',value:2.4,color:'#b9b6b6'},

	];

	var thelimitation = document.getElementById("limitation")
	if (thelimitation) {
		const limitation = new Chart(thelimitation, {
			type: "doughnut",
			data: {
				labels: datalimitation.map((row) => row.title),
				datasets: [{
					label: "",
					data: datalimitation.map((row) => row.value),
					backgroundColor: datalimitation.map(
						(row) => row.color),
					borderWidth: 0,
					weight: 8,
					hoverOffset: 0
				}, ],
			},
			options: chartOptionsDonut02,
		})
	}

}
